<template>
  <div>
    <el-button
      icon="el-icon-plus"
      type="primary"
      size="small"
      @click="editItem()"
      v-permission="
        template.category == 1 ? Auth.itemNew : Auth.instrumentItemNew
      "
      >添加{{ template.name }}</el-button
    >
    <!-- <el-button
      type="danger"
      size="small"
      @click="batchScrapItem"
      v-permission="
        template.category == 1 ? Auth.itemScrap : Auth.instrumentItemScrap
      "
      >批量报废</el-button
    > -->
    <file-button
      v-permission="
        template.category == 1 ? Auth.itemIE : Auth.instrumentItemIE
      "
      obj="item"
      :filter="filter"
      :templateId="template.id"
      @importCallback="importCallback"
    ></file-button>
    <el-table
      :data="items"
      border
      size="small"
      class="mt-10 table-fixed"
      @selection-change="handleSelectionChange"
      ref="table"
      v-loading="loading"
    >
      <!-- <el-table-column type="selection" width="55" :selectable="selectable">
      </el-table-column> -->
      <el-table-column align="center" label="编号" min-width="120" fixed="left">
        <template slot-scope="scope">
          <ItemLink :model="scope.row">
            {{ scope.row.code }}
            <el-tag size="mini" type="primary" v-if="scope.row.type == 2"
              >耗材</el-tag
            >
          </ItemLink>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="发往基地"
        prop="base.name"
        min-width="120"
        v-if="template.category == 1"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="库存基地"
        min-width="120px"
        v-if="template.category == 2"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.base.name || '无' }}
          </div>
          <div class="text-danger" v-if="scope.row.receive_base_id">
            {{ `（待${scope.row.receive_base.name}接收）` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="发往钻井"
        min-width="120px"
        v-if="template.category == 2"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.drill_well.well_number || '无' }}
          </div>
          <div class="text-danger" v-if="scope.row.receive_well_id">
            {{ `（待${scope.row.receive_well.well_number}接收）` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="使用次数"
        prop="used_count"
      ></el-table-column>
      <el-table-column
        align="center"
        label="维修次数"
        prop="repair_count"
      ></el-table-column>
      <el-table-column
        align="center"
        label="总工作时长"
        prop="total_man_hour"
        min-width="100"
      ></el-table-column>
      <el-table-column
        align="center"
        label="最近维修后工作时长/寿命天数"
        prop="current_man_hour"
        min-width="190"
      >
        <template slot-scope="scope"
          >{{
            scope.row.last_repair_date
              ? `${scope.row.current_used_hour} / ${scope.row.current_life_count}`
              : '无维修日期'
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="整机编号" min-width="140">
        <template slot-scope="scope">
          <template v-if="scope.row.status == 2">
            <ProductLink :product="scope.row.product"></ProductLink>
            <!-- {{ scope.row.product.code || '-' }} -->
          </template>
          <template v-else>-</template>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="型号"
        prop="model_number"
      ></el-table-column>
      <el-table-column
        align="center"
        :label="param.label"
        :prop="param.key"
        v-for="param in template.custom_params"
        :key="param.label + param.key"
        :min-width="labelWidth(param.label)"
      >
        <template slot-scope="scope">
          {{
            scope.row.custom_params.filter((item) => item.label == param.label)
              .length > 0
              ? scope.row.custom_params.filter(
                  (item) => item.label == param.label,
                )[0].value
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="期初使用时间"
        prop="start_man_hour"
        min-width="100"
      ></el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <ItemStatus :status="scope.row.status"></ItemStatus>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="预测寿命"
        prop="age"
      ></el-table-column>
      <el-table-column
        align="center"
        label="组装基地"
        prop="install_base.name"
        min-width="120"
      >
      </el-table-column>
      <!-- <el-table-column align="center" label="创建时间" min-width="100">
        <template slot-scope="scope">{{
          $time(scope.row.created_at).format('YYYY-MM-DD')
        }}</template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        align="center"
        min-width="150"
        fixed="right"
      >
        <template slot-scope="scope">
          <div
            v-if="
              template.category == 2 &&
              scope.row.status == 1 &&
              $store.state.userInfo.base_id
            "
            v-permission="Auth.instrumentItemStockManage"
          >
            <template
              v-if="
                !scope.row.receive_base_id &&
                !scope.row.drill_well_id &&
                !scope.row.receive_well_id &&
                scope.row.base_id == $store.state.userInfo.base_id
              "
            >
              <el-link
                type="primary"
                class="font-12 ml-5"
                :underline="false"
                @click="itemStockOut(scope.row, scope.$index)"
                >出库{{
              }}</el-link>
              <el-link
                type="primary"
                class="font-12 ml-5"
                :underline="false"
                @click="itemSendToWell(scope.row, scope.$index)"
                >发往钻井</el-link
              >
            </template>
            <el-popconfirm
              v-if="
                scope.row.base_id == $store.state.userInfo.base_id &&
                ((scope.row.receive_base_id && !scope.row.receive_well_id) ||
                  (scope.row.receive_well_id &&
                    scope.row.receive_well_id == scope.row.drill_well_id))
              "
              title="确认撤回该配件吗？"
              @confirm="itemStockRecall(scope.row, scope.$index)"
            >
              <el-link
                slot="reference"
                type="danger"
                class="font-12 ml-5"
                :underline="false"
                >撤回</el-link
              >
            </el-popconfirm>
            <el-link
              v-if="scope.row.receive_base_id == $store.state.userInfo.base_id"
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              @click="itemStockReject(scope.row, scope.$index)"
              >拒收</el-link
            >
            <el-popconfirm
              v-if="
                !scope.row.base_id ||
                (scope.row.receive_base_id == $store.state.userInfo.base_id &&
                  scope.row.drill_well_id == 0)
              "
              title="确认入库该配件吗？"
              @confirm="itemStockIn(scope.row, scope.$index)"
            >
              <el-link
                slot="reference"
                type="danger"
                class="font-12 ml-5"
                :underline="false"
                >确认入库</el-link
              >
            </el-popconfirm>
            <el-popconfirm
              v-if="
                scope.row.receive_base_id == $store.state.userInfo.base_id &&
                scope.row.drill_well_id > 0
              "
              title="确认该配件已从钻井返回吗？"
              @confirm="itemReceiveConfirm(scope.row, scope.$index)"
            >
              <el-link
                slot="reference"
                type="danger"
                class="font-12 ml-5"
                :underline="false"
                >确认接收</el-link
              >
            </el-popconfirm>
          </div>
          <el-link
            v-if="[1, 3, 4].includes(scope.row.status)"
            @click="scrapItem(scope.row, scope.$index)"
            v-permission="
              template.category == 1 ? Auth.itemScrap : Auth.instrumentItemScrap
            "
            type="danger"
            class="font-12"
            :underline="false"
            >{{ scope.row.status == 1 ? '报废' : '恢复' }}</el-link
          >
          <el-popconfirm
            title="确认删除该配件吗？"
            @confirm="hanldeDelte(scope.row, scope.$index)"
          >
            <el-link
              slot="reference"
              v-permission="
                template.category == 1
                  ? Auth.itemDelete
                  : Auth.instrumentItemDelete
              "
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              >删除</el-link
            >
          </el-popconfirm>
          <el-link
            v-if="scope.row.status != 3"
            v-permission="
              template.category == 1 ? Auth.itemEdit : Auth.instrumentItemEdit
            "
            class="font-12 ml-5"
            type="primary"
            :underline="false"
            @click="editItem(scope.row, scope.$index)"
            >编辑</el-link
          >
          <el-link
            v-permission="
              template.category == 1
                ? Auth.itemDetail
                : Auth.instrumentItemDetail
            "
            :underline="false"
            class="font-12 ml-5"
            type="primary"
            @click="
              $router.push(
                `/${template.category == 1 ? 'items' : 'instrument_items'}/${
                  scope.row.id
                }`,
              )
            "
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :page-sizes="[10, 20, 50, 100]"
      :current-page.sync="filter.page"
      @current-change="getData"
      @size-change="handleSizeChange"
      layout="total, sizes, prev, pager, next"
      :total="total"
    ></el-pagination>
    <ItemFormer
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></ItemFormer>
    <StockoutFormer
      :model="model"
      :show.sync="stockoutFormerVisible"
      @updated="updatedCallback"
    ></StockoutFormer>
    <WellFormer
      :model="model"
      :show.sync="wellFormerVisible"
      @updated="updatedCallback"
    ></WellFormer>
    <ScrapFormer
      :model="model"
      :show.sync="scrapFormerVisible"
      @callback="scrapCallback"
    ></ScrapFormer>
  </div>
</template>

<script>
import {
  itemList,
  itemDelete,
  itemScrap,
  itemStockIn,
  itemReceiveComfirm,
  itemRecall,
  itemReject,
} from '@/service/getData'
import ItemFormer from './former'
import StockoutFormer from './stockout_former'
import WellFormer from './well_former'
import ScrapFormer from '../../components/ScrapFormer.vue'

export default {
  components: {
    ItemFormer,
    StockoutFormer,
    WellFormer,
    ScrapFormer,
  },
  props: {
    template: Object,
    filter: Object,
  },
  data() {
    return {
      items: [],
      total: 0,
      model: {},
      formerVisible: false,
      stockoutFormerVisible: false,
      scrapFormerVisible: false,
      wellFormerVisible: false,
      editIndex: 0,
      selectedIDs: [],
      loading: false,
    }
  },
  computed: {
    labelWidth() {
      return function (label) {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        context.font = '14px Microsoft YaHei'
        const dimension = context.measureText(label)

        let width = dimension.width + 20
        if (width < 90) {
          width = 90
        }
        return width
      }
    },
  },
  created() {
    // this.getData()
    // this.filter.item_template_id = this.template.id
  },
  methods: {
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })
      let data = this.clone(this.filter)
      data.page -= 1
      this.loading = true
      let res = await itemList(data)
      if (res.status == 0) {
        this.items = res.data.list
        this.total = res.data.count
        this.loading = false
      }
    },
    async importCallback() {
      this.filter.page = 1
      this.getData()
    },
    editItem(item, index) {
      if (!item) {
        this.editIndex = -1
        this.model = {
          item_template_id: this.template.id,
          base_id: '',
          install_base_id: '',
          code: '',
          name: this.template.name,
          type: this.template.type,
          category: this.template.category,
          model_number: '',
          custom_params: this.template.custom_params || [],
          start_man_hour: 0,
          status: 1,
          age: 0,
          remark: '',
          attachments: [],
        }
      } else {
        this.model = this.clone(item)
        this.model.custom_params = this.copyCustomParam(
          this.template.custom_params,
          item.custom_params,
        )
        this.editIndex = index
      }
      this.formerVisible = true
    },

    itemStockOut(item, index) {
      this.model = {
        receive_base_id: '',
        id: item.id,
      }
      this.editIndex = index
      this.stockoutFormerVisible = true
    },
    async itemStockIn(item, index) {
      let res = await itemStockIn({ id: item.id })
      if (res.code == 0) {
        this.$set(this.items, index, res.data)
        this.$emit('baseCheck')
      }
    },
    itemSendToWell(item, index) {
      this.model = {
        base_id: item.base_id,
        receive_well_id: '',
        id: item.id,
      }
      this.editIndex = index
      this.wellFormerVisible = true
    },
    async itemReceiveConfirm(item, index) {
      let res = await itemReceiveComfirm({ id: item.id })
      if (res.code == 0) {
        this.$set(this.items, index, res.data)
        this.$emit('baseCheck')
      }
    },

    handleSizeChange(size) {
      this.filter.size = size
      this.filter.page = 1
      this.getData()
    },

    selectable(row, index) {
      return row.status == 1
    },
    handleSelectionChange(items) {
      this.selectedIDs = items.map((item) => {
        return item.id
      })
    },

    // 撤回
    async itemStockRecall(item, index) {
      let res = await itemRecall({
        id: item.id,
      })
      if (res.code == 0) {
        this.$set(this.items, index, res.data)
        this.$notify.success('已撤回！')
      }
    },

    //拒收
    itemStockReject(item, index) {
      this.$prompt('拒收原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (value) => {
          return !!value
        },
        inputErrorMessage: '拒收原因不能为空',
      }).then(async ({ value }) => {
        let res = await itemReject({
          id: item.id,
          remark: value,
        })
        if (res.code == 0) {
          this.$set(this.items, index, res.data)
          this.$notify.success('已拒收！')
          this.$emit('baseCheck')
        }
      })
    },

    async batchScrapItem() {
      if (this.selectedIDs.length == 0) {
        this.$alert('请至少选择一个配件')
        return
      }

      this.$confirm('确认报废选中的配件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await itemScrap({ ids: this.selectedIDs })
          if (res.code == 0) {
            this.getData()
            this.clearTableSelected()
            this.$message({
              message: `成功报废 ${res.data.scrap_count} 个配件！`,
              type: 'success',
            })
          }
        })
        .catch(() => {})
    },

    updatedCallback(data) {
      if (this.editIndex == -1) {
        this.items.unshift(data)
        this.clearTableSelected()
      } else {
        this.$set(this.items, this.editIndex, data)
      }
    },

    clearTableSelected() {
      this.$refs.table.clearSelection()
    },

    async scrapItem(item, index) {
      if (item.status == 1) {
        this.model = {
          category: 2,
          names: [item.code],
          ids: [item.id],
          attachments: [],
          remark: '',
        }
        this.scrapFormerVisible = true
        this.editIndex = index
        return
      }

      this.$confirm('确认恢复该配件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        let res = await itemScrap({
          ids: [item.id],
        })

        if (res.code == 0) {
          this.getData()
          this.clearTableSelected()
          this.$notify.success('操作成功！')
        }
      })
    },

    scrapCallback() {
      this.getData()
      this.clearTableSelected()
      this.$notify.success('报废成功！')
    },

    async hanldeDelte(item, index) {
      let res = await itemDelete(item.id)
      if (res.code == 0) {
        this.items.splice(index, 1)
        this.clearTableSelected()
      }
    },
  },
}
</script>

<style>
.table-fixed .el-table__fixed-right,
.table-fixed .el-table__fixed {
  height: 100% !important;
}
</style>
